<template>
  <img src="../assets/mastercard3d.png">
</template>

<script>
export default {
  name: 'OMastercard3d'
}
</script>
